<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',

  created () {
    this.getOemInfo()
  },

  methods: {
    getOemInfo () {
      this.$store.dispatch('getOemInfo', {
        query: {
          d: location.hostname,
          v: 'c'
        }
      }).then(response => {
        if (response) {
          document.title = `${response.data.name} - 客户管理系统`
        }
      })
    }
  }
}
</script>
